export interface CardValidationResult {
  isValid: boolean;
  error?: string;
}

export const validateCardNumber = (value: string): boolean => {
  const cleaned = value.replace(/\s/g, '');
  return /^\d{13,19}$/.test(cleaned);
};

export const validateExpiryDate = (value: string): boolean => {
  const parts = value.split('/');
  if (parts.length !== 2) {
    return false;
  }

  const month = parseInt(parts[0] || '0', 10);
  const year = parseInt(parts[1] || '0', 10);
  const currentYear = new Date().getFullYear() % 100;

  return (
    month >= 1 && month <= 12 && year >= currentYear && year <= currentYear + 20
  );
};

export const validateCVV = (value: string): boolean => {
  return /^\d{3,4}$/.test(value);
};

export const detectCardBrand = (
  cardNumber: string,
): 'VISA' | 'MASTERCARD' | 'AMEX' | 'DISCOVER' | undefined => {
  const cleaned = cardNumber.replace(/\s/g, '');

  if (/^4/.test(cleaned)) {
    return 'VISA';
  }
  if (/^5[1-5]/.test(cleaned)) {
    return 'MASTERCARD';
  }
  if (/^3[47]/.test(cleaned)) {
    return 'AMEX';
  }
  if (/^6(?:011|5)/.test(cleaned)) {
    return 'DISCOVER';
  }

  return undefined;
};

export const formatCardNumber = (value: string): string => {
  const cleaned = value.replace(/\s/g, '');
  const groups = cleaned.match(/.{1,4}/g) || [];
  return groups.join(' ');
};

export const formatExpiryDate = (value: string): string => {
  const digitsOnly = value.replace(/\D/g, '');

  if (digitsOnly.length > 2) {
    return digitsOnly.substring(0, 2) + '/' + digitsOnly.substring(2, 4);
  }

  return digitsOnly;
};
